const jobTypes = ['카페(운죽정)', '편의점', '식당', '행사', '사무'];

export default jobTypes;

